// The shared Denied state (viewer role or unauthenticated deep link) used across
// screens 1-6 and screen 8 (slice-2-onboarding.md §4.2, §11.3). The server is the real
// gate (@Roles/RolesGuard, ADR-0016 §4) - this is UI convenience only, never trusted
// hiding (§2.3). `title` (added Slice 3, docs/design/slice3-knowledge-ux.md §2.3/§6.2
// item 10) generalizes the previously-hardcoded role-denial heading so this same card
// also renders the cross-tenant "not found, never not yours" state (byte-identical
// not_found/forbidden, packages/shared/src/http/knowledge.ts:17-19) - existing call
// sites are unaffected since the default reproduces the prior fixed text exactly.
import { Link } from "react-router-dom";

export const DeniedCard = ({
  message,
  title = "Only an owner or admin can do this",
}: {
  readonly message: string;
  readonly title?: string;
}): React.JSX.Element => (
  <div className="card state-card denied" role="region" aria-label="Access denied">
    <div className="h3">{title}</div>
    <p className="muted">{message}</p>
    <Link className="btn btn-primary" to="/apps">
      Back to your apps
    </Link>
  </div>
);
